import { AutogenModelEdiorderProfile, AutogenRowEdiorderProfile } from "./autogen/AutogenModelEdiorderProfile";

export class ModelEdiorderProfile extends AutogenModelEdiorderProfile<RowEdiorderProfile> {
    constructor() {
        super(RowEdiorderProfile);
    }
}

export class RowEdiorderProfile extends AutogenRowEdiorderProfile {
}